import { __decorate } from "tslib";
import { Action, Getter, Mutation, State } from "@/types";
import { service } from "@/services";
export class UsersModule {
    constructor() {
        this.users = [];
        this.count = 0;
        this.axiosError = null;
    }
    setItems(users) {
        this.users = users;
    }
    setTotal(count) {
        this.count = count;
    }
    setError(error) {
        this.axiosError = error;
    }
    get list() {
        return this.users;
    }
    get total() {
        return this.count;
    }
    get errorList() {
        return this.axiosError;
    }
    async get(options) {
        try {
            const data = await service.users.get(options);
            this.setItems(data.items);
            this.setTotal(data.total);
        }
        catch (error) {
            this.setError(error);
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async add(user) {
        try {
            await service.users.add(user);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
        }
    }
    async edit(user) {
        try {
            await service.users.edit(user);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async delete(userId) {
        try {
            await service.users.delete(userId);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
}
__decorate([
    State()
], UsersModule.prototype, "users", void 0);
__decorate([
    State()
], UsersModule.prototype, "count", void 0);
__decorate([
    State()
], UsersModule.prototype, "axiosError", void 0);
__decorate([
    Mutation()
], UsersModule.prototype, "setItems", null);
__decorate([
    Mutation()
], UsersModule.prototype, "setTotal", null);
__decorate([
    Mutation()
], UsersModule.prototype, "setError", null);
__decorate([
    Getter()
], UsersModule.prototype, "list", null);
__decorate([
    Getter()
], UsersModule.prototype, "total", null);
__decorate([
    Getter()
], UsersModule.prototype, "errorList", null);
__decorate([
    Action()
], UsersModule.prototype, "get", null);
__decorate([
    Action()
], UsersModule.prototype, "add", null);
__decorate([
    Action()
], UsersModule.prototype, "edit", null);
__decorate([
    Action()
], UsersModule.prototype, "delete", null);
